<template>
	<b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <levy-office-create-or-update v-model="levyOffice" :errors="errors"></levy-office-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="carrier-classification"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import LevyOfficeCreateOrUpdate from './components/LevyOfficeCreateOrUpdate.vue'
import SystemDataApi from '@/api/system-data'

export default {
	components:{
        BCard,
        LevyOfficeCreateOrUpdate,
	},
	data(){
		return{
			editing:false,
            errors:{},
            loading:false,
            levyOffice:{
                Id: 0,
                Name: null,
                Iban: null,
                AccountNumber:null,
                ProvinceId: null,
                DistrcitId: null,
                TaxNumber: null,
                TaxAdministrationId: null,
                BankId: null,
                LevyOfficeAccountType: null
            },
            fields:[
                { name:"İcra Dairesi",key:"Name", thClass:"w-10",sortable:true},
                { name:"IBAN",key:"Iban", thClass:"w-14"},
                { name:"Hesap No",key:"AccountNumber", thClass:"w-6"},
                { name:"İl",key:"ProvinceName", thClass:"w-14"},
                { name:"İlçe",key:"DistrictName", thClass:"w-14"},
                { name:"Banka",key:"BankName", thClass:"w-14"},
                { name:"Hesap Türü",key:"LevyOfficeAccountTypeValue", thClass:"w-14"},
                { name:"Vergi Dairesi",key:"TaxAdministrationName", thClass:"w-14"},
                { name:"Vergi Numarası",key:"TaxNumber", thClass:"w-14"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
		}
	},
	methods:{
		clearForm(){
            this.editing = false
            this.levyOffice.Id = 0
            this.levyOffice.Name = null
            this.levyOffice.Iban = null
            this.levyOffice.AccountNumber = null
            this.levyOffice.ProvinceId = null
            this.levyOffice.DistrcitId = null
            this.levyOffice.TaxNumber = null
            this.levyOffice.TaxAdministrationId = null
            this.levyOffice.BankId = null
            this.levyOffice.LevyOfficeAccountType = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.levyOffice.Id = item.Id
            this.levyOffice.Name = item.Name
            this.levyOffice.Iban = item.Iban
            this.levyOffice.AccountNumber = item.AccountNumber
            this.levyOffice.ProvinceId = item.ProvinceId
            this.levyOffice.DistrcitId = item.DistrcitId
            this.levyOffice.TaxNumber = item.TaxNumber
            this.levyOffice.TaxAdministrationId = item.TaxAdministrationId
            this.levyOffice.BankId = item.BankId
            this.levyOffice.LevyOfficeAccountType = item.LevyOfficeAccountType
            this.$showModal('create-or-update')
        },
        provider(data){
            return SystemDataApi.LevyOffice.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            SystemDataApi.LevyOffice.CreateOrUpdate(this.editing,this.levyOffice)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli icra dairesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemDataApi.LevyOffice.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	}
}
</script>

<style>

</style>